import { render, staticRenderFns } from "./ServeContract.vue?vue&type=template&id=62c0e7fc"
import script from "./ServeContract.vue?vue&type=script&lang=js"
export * from "./ServeContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports